
export const initializeSignatureUpload = (container: HTMLElement, uploadInputId: string, previewContainerId: string, handlerLabelId: string, errorContainerId: string) => {
  const uploadInput = container.querySelector(`#${uploadInputId}`) as HTMLInputElement;
  const previewContainer = container.querySelector(`#${previewContainerId}`) as HTMLElement;
  const handlerLabel = container.querySelector(`#${handlerLabelId}`) as HTMLElement;
  const errorContainer = container.querySelector(`#${errorContainerId}`) as HTMLElement;

  if (!uploadInput || !previewContainer) return;

  const handleFileRead = (input: HTMLInputElement) => {
    if (input.files && input.files[0]) {
      const file = input.files[0];
      

      const reader = new FileReader();
      reader.onload = function (e) {
        if (e.target?.result) {
          previewContainer.innerHTML = `<img src="${e.target.result}" style="width:200px;height:70px;" />`;
          if (handlerLabel) handlerLabel.innerText = "Re-upload Signature";
          if (errorContainer) errorContainer.style.display = "none";
        }
      };
      reader.readAsDataURL(file);
    }
  };

  uploadInput.addEventListener("change", function () {
    handleFileRead(this as HTMLInputElement);
  });

  previewContainer.addEventListener("click", function () {
    this.innerHTML = "";
    uploadInput.value = "";
    if (handlerLabel) {
      handlerLabel.style.display = "inline-block";
      handlerLabel.innerText = "Upload Signature";
    }
  });
};

export const initializeCheckbox = (container: HTMLElement, checkboxId: string, errorContainerId: string) => {
  const checkbox = container.querySelector(`#${checkboxId}`) as HTMLInputElement;
  const errorContainer = container.querySelector(`#${errorContainerId}`) as HTMLElement;

  if (checkbox && errorContainer) {
    checkbox.addEventListener("change", function () {
      if (this.checked) {
        errorContainer.style.display = "none";
      }
    });
  }
};

export const injectSignedImageAndHideForm = (container: HTMLElement, signaturePath: string | null, imageBaseUrl: string | undefined) => {
  const elementsToHideSelectors = [
    "#employeeImageUpload",
    "#employeeSignatureHandler",
    "#employeeSignatureError",
    "#training",
    "#compliance",
    "#responsibility",
    "#trainingError",
    "#complianceError",
    "#responsibilityError",
    ".submit-btn",
    ".policy-acknowledgement",
  ];

  elementsToHideSelectors.forEach((selector) => {
    const element = container.querySelector<HTMLElement>(selector);
    if (element) element.style.display = "none";
  });

  ["training", "compliance", "responsibility"].forEach((id) => {
    const label = container.querySelector<HTMLElement>(`label[for="${id}"]`);
    if (label) label.style.display = "none";
  });

  const privacyPolicyContainer = container.querySelector<HTMLElement>(".privacy-policy");
  if (privacyPolicyContainer) privacyPolicyContainer.style.display = "none";

  if (signaturePath) {
    const employeeSignaturePreview = container.querySelector<HTMLElement>("#employeeSignaturePreview");
    if (employeeSignaturePreview) {
      employeeSignaturePreview.innerHTML = `<img src="${imageBaseUrl + signaturePath}" style="width:200px;height:70px;" />`;
      employeeSignaturePreview.style.pointerEvents = "none";
    }
  }

  const allAvatarPreviews = container.querySelectorAll<HTMLElement>(".avatar-preview");
  allAvatarPreviews.forEach((preview) => (preview.style.pointerEvents = "none"));
};

export const validateFormInputs = (container: HTMLElement) => {
  let isValid = true;

  const employeeInput = container.querySelector("#employeeImageUpload") as HTMLInputElement;
  const employeeError = container.querySelector("#employeeSignatureError") as HTMLElement;
  if (!employeeInput?.files?.length) {
    if (employeeError) employeeError.style.display = "block";
    isValid = false;
  }

  const checkboxesToValidate = [
    { id: "training", errorId: "trainingError" },
    { id: "compliance", errorId: "complianceError" },
    { id: "responsibility", errorId: "responsibilityError" },
  ];

  checkboxesToValidate.forEach((check) => {
    const checkbox = container.querySelector(`#${check.id}`) as HTMLInputElement;
    const errorContainer = container.querySelector(`#${check.errorId}`) as HTMLElement;
    if (checkbox && !checkbox.checked) {
      if (errorContainer) errorContainer.style.display = "block";
      isValid = false;
    }
  });

  return { isValid, employeeFile: employeeInput?.files?.[0] || null };
};
